<template>
  <div class="inquiry-add">
    <h1 class="title">
      {{ $t('message["622"]') }}
    </h1>

    <!-- tab 切换 -->
    <!-- ref="tabs" -->
    <tab-nav
      :data="baseFormData"
      :selected="selected"
      :is-anchor="true"
      @change="tabNavChange"
    />

    <!-- form 表单 -->
    <my-form
      v-if="!loading"
      ref="myForm"
      :data="baseFormData"
      :set-tab-index="tabNavChange"
    />
    <a-spin
      v-else
      class="spin-fixed-center"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import TabNav from '@/components/pc/TabNav'
import MyForm from './Form'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    TabNav,
    MyForm
  },
  data () {
    return {
      selected: 'base_info'
      // scroll: null
    }
  },
  computed: {
    ...mapState('inquery/addConfigData', ['baseinfo']),
    ...mapState('inquery/addConfigData', [
      'loading'
    ]),
    ...mapGetters('inquery/addConfigData', [
      'formData'
    ]),
    baseFormData () {
      let data = Object.assign({}, this.formData)
      const { info: inquiryInfo = {} } = data || {}
      const { child: infoChild = {} } = inquiryInfo
      if (infoChild && infoChild[0]) {
        let { fieldvalue: trueName } = infoChild[0]
        if (!trueName) {
          trueName = this.baseinfo && this.baseinfo.truename

          infoChild[0].fieldvalue = trueName
          this.$set(data.info.child, 0, infoChild[0])
        }
      }

      return this.sortObj(data)
    },
    formHistoryId () {
      return this.$route.query.form_history_id
    },
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      let title = this.$t('message["622"]') + projectname + comname
      return title
    },
    clueId () {
      const { clue_id: id = '' } = this.$route.query
      return id
    }
  },

  watch: {
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },

  async created () {
    await this.fetchData()
    // 清空关联人员列表
    this.SET_RELATE_LIST_DATA([])
    eventBus.$on('fetchAddConfig', this.fetchData)
  },
  beforeDestroy () {
    eventBus.$off('fetchAddConfig', this.fetchData)
  },

  methods: {
    ...mapActions('inquery/addConfigData', ['fetchDetail']),
    ...mapMutations('inquery/relateData', ['SET_RELATE_LIST_DATA']),
    async fetchData () {
      let params = {}
      if (this.formHistoryId) {
        params.form_history_id = this.formHistoryId
      }
      if (this.clueId) {
        params.clue_id = this.clueId
      }
      const chain = await this.fetchDetail()
      chain
        .params(params)
      chain
        .params()
        .onSuccess(res => {
          document.title = this.documentTitle
        })
        .fetch()
    },
    tabNavChange (k, event) {
      /* if (!event._constructed) {
        // 如果不存在这个属性,则为原生点击事件，不执行下面的函数
        return
      } */
      this.selected = k
    },
    /**
     * 将对象根据某一数字键进行排序,防止在Safari上自动根据【sort】排序
     * @param {Object} data 原始为排序的对象
     * @param {String} key 排序参考数字键
     * @return {Object}
     */
    sortObj (data, key = 'sort') {
      let aData = []
      let snapData = []
      let result = {}
      for (let k in data) {
        let item = data[k]
        if (k === 'audit_info' || k === 'permission_info') {
          continue
        }
        /* if ('sort' in item) {
          aData[item.sort - 1] = item
        } else {
          snapData.push(item)
        } */
        snapData.push(item)
      }
      aData = aData.concat(snapData)
      for (let i = 0; i < aData.length; i++) {
        let item = aData[i]
        if (item && 'fieldkey' in item && item.child && item.child.length) {
          result[item.fieldkey] = item
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.inquiry-add::v-deep {
  .ant-form-item-label {
    white-space: normal;
  }
}
</style>
